import {
	type RelayGraphQLError,
	isRelayGraphQLError as isGraphQLErrorInterop,
} from '@confluence/relay-errors/entry-points/RelayError.ts';

export function isGraphQLError(value: unknown): value is RelayGraphQLError {
	return isGraphQLErrorInterop(value);
}
